import { useState } from "react";
import { useSelector } from "react-redux";
import SongRow from "../common/SongRow";
import { selectIsHost } from "../../selectors";

/** The favourites: the host's list, browsable by everyone in the session, kept on the device for a dead signal. */
const FavoritesPage = () => {
  const { songs, isLoaded, loadFailed } = useSelector((state) => state.library);
  const isHost = useSelector(selectIsHost);
  const keepOffline = useSelector((state) => state.preferences.keepFavoritesOffline);
  const [query, setQuery] = useState("");
  const term = query.trim().toLowerCase();
  const visible = term ? songs.filter((song) => `${song.Title} ${song.Artist || ""}`.toLowerCase().includes(term)) : songs;

  let body;
  if (!isLoaded) body = <div className="loading">Loading…</div>;
  else if (songs.length === 0 && loadFailed) body = <div className="empty">Couldn’t load the favourites. They will appear when the connection is back.</div>;
  else if (songs.length === 0) body = <div className="empty">{isHost ? "No favorites yet. Tap the heart on any song." : "The host has not marked any favourites yet."}</div>;
  else if (visible.length === 0) body = <div className="empty">None of the favourites match “{query.trim()}”.</div>;
  else
    body = (
      <ol className="stack stack-tight">
        {visible.map((song) => (
          <SongRow key={song.Id} song={song} meta={[song.Artist, keepOffline ? "Saved offline" : null, song.Verses?.length ? `${song.Verses.length} ${song.Verses.length === 1 ? "section" : "sections"}` : null].filter(Boolean).join(" · ")} />
        ))}
      </ol>
    );

  return (
    <div className="page" data-screen-label="Favorites">
      <div className="page-head">
        <h2 className="page-title">Favorites</h2>
        <p className="page-sub">{isHost ? (keepOffline ? "Kept on this phone. Works with no signal." : "Your list for every session you host.") : "The host’s favourites."}</p>
      </div>
      {songs.length > 5 && (
        <div className="search">
          <span className="glyph" aria-hidden="true">
            ⌕
          </span>
          <input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Search favourites" aria-label="Search favourites" autoComplete="off" />
        </div>
      )}
      {body}
    </div>
  );
};

export default FavoritesPage;
